import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  saveAsMappings,
  getInputColumnsData,
  getEditStateData,
  getChangesFlag,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";
import DropDownMenu from "../components/DropDownMenu";
import Button from "../components/Button";
import CheckBox from "../components/CheckBox";
import { columnDataTypesOptions } from "../utils";
import { showAddedRulesToast } from "../helpers";
import InputField from "../components/InputField";
const initialObjectProperties = {
  inputColumn: "",
  findType: "",
  ranges: false,
  exclusiveStartDate: false,
  searchValue: "",
  appliedRule: 2,
  output: "",
};
const FindPage = () => {
  const dispatch = useDispatch();
  const [findObject, setfindObject] = useState(initialObjectProperties);
  const inputColsData = useSelector(getInputColumnsData);
  const state = useSelector(getEditStateData);
  const [isInLocalEditMode, setIsInLocalEditMode] = useState(false);
  const USfalg = useSelector(getChangesFlag);
  useEffect(() => {
    if (state?.type === "find") {
      setfindObject({
        ...state.data,
      });
      setIsInLocalEditMode(true);
    }
  }, [state?.data, state?.type, state?.data?._id]);

  useEffect(() => {
    if (findObject?.findType === "3") {
      setfindObject((prev) => ({
        ...prev,
        searchValue: "",
      }));
    }
    if (!findObject?.ranges) {
      setfindObject((prev) => ({
        ...prev,
        exclusiveStartDate: false,
      }));
    }
  }, [findObject?.findType, findObject.ranges]);
  const handleOnChange = (e) => {
    setfindObject((prev) => {
      return {
        ...prev,
        [e.target.name]:
          e.target.type === "checkbox" ? e.target.checked : e.target.value,
      };
    });
    if (!USfalg) {
      dispatch(setunSavedRulesChanges(true));
    }
  };

  const handleAddNewRule = () => {
    dispatch(
      saveAsMappings({
        ...findObject,
      }),
    );
    showAddedRulesToast(
      findObject.appliedRule,
      isInLocalEditMode ? "Updated" : "added",
    );
    reset();
  };

  const reset = () => {
    setfindObject(initialObjectProperties);
    setIsInLocalEditMode(false);
  };

  return (
    <div className="w-full grid grid-cols-1 xl:grid-cols-2 gap-4 p-2">
      <DropDownMenu
        label="Select Input Column"
        name="inputColumn"
        value={findObject.inputColumn}
        options={inputColsData.map((item) => ({
          label: item.inColChr,
          value: item.inColChr,
        }))}
        onChange={(e) => handleOnChange(e)}
        required={true}
      />
      <DropDownMenu
        label="Select Find"
        name="findType"
        value={findObject.findType}
        options={columnDataTypesOptions}
        onChange={(e) => handleOnChange(e)}
        required={true}
      />
      {/*  Show search value input field only for Text and Numeric types */}
      {(findObject.findType === "1" || findObject.findType === "2") && (
        <InputField
          label={"Search Value"}
          name={"searchValue"}
          type="Text"
          placeholder={"Enter search value"}
          value={findObject.searchValue}
          onChange={(e) => handleOnChange(e)}
          required={true}
        />
      )}
      <div className=" w-full flex items-end gap-2">
        <CheckBox
          name={"ranges"}
          chkBoxText={"Find Ranges?"}
          checked={findObject.ranges}
          onChange={handleOnChange}
        />
        {
          // inclusive/exclusive checkbox
          findObject.ranges && (
            <CheckBox
              name={"exclusiveStartDate"}
              chkBoxText={`Exclusive Start Date`}
              checked={findObject.exclusiveStartDate}
              onChange={handleOnChange}
            />
          )
        }
      </div>

      <div className="flex gap-4 w-full xl:col-span-2">
        <Button
          btnText={`${isInLocalEditMode ? "Update" : "Save"}`}
          handleOnClick={handleAddNewRule}
          disabled={
            findObject.inputColumn === "" ||
            findObject.findType === "" ||
            ((findObject?.findType === "1" || findObject.findType === "2") &&
              !findObject?.searchValue?.trim())
          }
        />
        <Button
          btnType="cancel"
          btnText={"Reset"}
          handleOnClick={() => reset()}
        />
      </div>
    </div>
  );
};

export default FindPage;
